import * as React from "react";
import { Icon } from "antd";
import { IEnlargeProps } from "../../utils/interface/smallTools";

// 扩大
class Enlarge extends React.Component<IEnlargeProps, any> {
  state = {
    enlarge: false
  };

  constructor(props: IEnlargeProps) {
    super(props);
  }

  onClick = () => {
    this.setState({
      enlarge: !this.state.enlarge
    });
    this.props.onClick(!this.state.enlarge);
  };

  getTitle = () => {
    return this.state.enlarge
      ? this.props.shrinkPlaecholder || "收缩"
      : this.props.enlargePlaceholder || "扩大";
  };

  render() {
    return (
      <React.Fragment>
        <Icon
          type={this.state.enlarge ? "shrink" : "arrows-alt"}
          title={this.getTitle()}
          style={{ cursor: "pointer" }}
          onClick={this.onClick}
        />
      </React.Fragment>
    );
  }
}

export default Enlarge;
